
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_18mml_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_18mml_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_18mml_119",
  "icon": "awsui_icon_gwq0h_18mml_133",
  "root": "awsui_root_gwq0h_18mml_151",
  "expand-button": "awsui_expand-button_gwq0h_18mml_168",
  "expanded": "awsui_expanded_gwq0h_18mml_175",
  "icon-container": "awsui_icon-container_gwq0h_18mml_179",
  "icon-container-container": "awsui_icon-container-container_gwq0h_18mml_184",
  "wrapper": "awsui_wrapper_gwq0h_18mml_188",
  "wrapper-default": "awsui_wrapper-default_gwq0h_18mml_195",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_18mml_195",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_18mml_198",
  "wrapper-container": "awsui_wrapper-container_gwq0h_18mml_201",
  "header-deprecated": "awsui_header-deprecated_gwq0h_18mml_217",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_18mml_248",
  "header": "awsui_header_gwq0h_18mml_217",
  "header-wrapper": "awsui_header-wrapper_gwq0h_18mml_255",
  "header-button": "awsui_header-button_gwq0h_18mml_265",
  "header-container-button": "awsui_header-container-button_gwq0h_18mml_265",
  "header-container": "awsui_header-container_gwq0h_18mml_265",
  "header-navigation": "awsui_header-navigation_gwq0h_18mml_297",
  "header-text": "awsui_header-text_gwq0h_18mml_329",
  "content": "awsui_content_gwq0h_18mml_97",
  "content-default": "awsui_content-default_gwq0h_18mml_336",
  "content-footer": "awsui_content-footer_gwq0h_18mml_339",
  "content-expanded": "awsui_content-expanded_gwq0h_18mml_342",
  "focusable": "awsui_focusable_gwq0h_18mml_346",
  "click-target": "awsui_click-target_gwq0h_18mml_357"
};
  